import { render } from "./PartnersCard.vue?vue&type=template&id=4e1d0b32"
import script from "./PartnersCard.vue?vue&type=script&lang=js"
export * from "./PartnersCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__